import { Type } from "class-transformer";
import { EnaioObject } from "src/modules/enaio/shared/EnaioObject";
import { OrdinaryObject } from "src/modules/utils/shared/ordinary-object.model";

export class EnaioDocumentResult {
    @Type(() => EnaioObject)
    doc: EnaioObject;
    token: string;
    seen = false;
    @Type(() => EnaioDocumentResult)
    remarkObjects: EnaioDocumentResult[];
    columns: OrdinaryObject;
}
